module.exports = new __parcel__URL__("net.b723cb4a.png").toString();